import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';

export function ReservationOptionSkeleton() {
  return (
    <Card sx={{ mb: 1 }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5">
            <Skeleton width="80%" />
          </Typography>
          <Typography sx={{ fontSize: '1.1rem' }} gutterBottom>
            <Skeleton width="60%" />
          </Typography>
        </Box>
        <Stack direction="row" spacing={2}>
          <Skeleton width={100} />
          <Skeleton variant="circular" width={24} height={24} />
        </Stack>
      </CardContent>
    </Card>
  );
}
